import MergePartsForm from '../../MergePartsForm'

import useMergePartsHandler from '../../../effects/merge-parts'

import { Part } from 'graphql'
import { heapEvent } from '@equipmentshare/heaper'

export type MergePartsModalProps = {
	formData: {
		part?: Part,
	},
	onCancel: () => void,
	onSuccess: () => void,
}

export default function MergePartsModal( { formData, onCancel, onSuccess }: MergePartsModalProps ) {
	const mergeParts = useMergePartsHandler()

	const handleSubmit = async( goodId: number, dupeId: number ) => {
		heapEvent( 'Inventory - Merge Parts Modal - Click - Submit', {} )
		return await mergeParts( goodId, dupeId )
	}

	const handleCancel = () => {
		heapEvent( 'Inventory - Merge Parts Modal - Click - Cancel', {} )
		onCancel()
	}

	return (
		<MergePartsForm
			fromPart={formData.part}
			onCancel={handleCancel}
			onSuccess={onSuccess}
			onSubmit={handleSubmit}
		/>
	)
}
